export function makePath(parts: string[]) {
  return (
    (parts[0] == "." || parts[0] == ".." ? "" : "/") +
    parts.map((part) => encodeURIComponent(part)).join("/")
  );
}
